<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-primary">
      <!-- Card stats -->
      <b-row> </b-row>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row class="justify-content-center">
        <b-col lg="12">
          <card header-classes="bg-transparent">
            <b-row class="mb-4">
              <b-col lg="10" md="12" class="d-flex align-items-center mb-4">
                <h2 slot="header" class="mb-0">รายละเอียดงาน</h2>
              </b-col>
              <b-col lg="2" md="12" class="text-right">
                <base-button type="info" class="" size="sm" block>
                  รายงานจากพนักงานขับรถ
                </base-button>
              </b-col>
            </b-row>
            <b-col lg="12">
              <b-tabs content-class="mt-3" fill>
                <b-tab title="ข้อมูลงาน" active>
                  <b-row>
                    <b-col lg="12"><h3>ข้อมูลงาน</h3></b-col>
                    <b-col lg="12">
                      <b-row class="align-items-center">
                        <b-col lg="2" md="12" class="text-lg-right mb-3">
                          <p class="m-0">สถานะงาน</p>
                        </b-col>
                        <b-col lg="10" md="12" class="mb-3">
                          <b-badge
                            variant="dark"
                            v-if="jobDetails.status === 'wait'"
                            block
                            >รอส่ง
                          </b-badge>
                          <b-badge
                            variant="warning"
                            v-else-if="jobDetails.status === 'pending'"
                            >กำลังจัดส่ง
                          </b-badge>
                          <b-badge
                            variant="success"
                            v-else="jobDetails.status === 'success'"
                            >ส่งสำเร็จ
                          </b-badge>
                        </b-col>
                        <b-col lg="2" md="12" class="text-lg-right mb-3">
                          <p class="m-0">ชื่องาน</p>
                        </b-col>
                        <b-col lg="10" md="12" class="mb-3">
                          <b-form-input
                            size="sm"
                            v-model="jobDetails.job_name"
                            disabled
                          ></b-form-input>
                        </b-col>
                        <b-col lg="2" md="12" class="text-lg-right mb-3">
                          <p class="m-0">กำหนดวันที่รับ</p>
                        </b-col>
                        <b-col lg="10" md="12" class="mb-3">
                          <b-form-input
                            size="sm"
                            v-model="jobDetails.sent_date"
                            disabled
                          ></b-form-input>
                        </b-col>
                        <b-col lg="2" md="12" class="text-lg-right mb-3">
                          <p class="m-0">กำหนดวันที่ส่ง</p>
                        </b-col>
                        <b-col lg="10" md="12" class="mb-3">
                          <b-form-input
                            size="sm"
                            v-model="jobDetails.sent_date"
                            disabled
                          ></b-form-input>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col lg="12"><h3>ข้อมูลลูกค้า</h3></b-col>
                    <b-col lg="12">
                      <b-row class="align-items-center">
                        <b-col lg="2" md="12" class="text-lg-right mb-3">
                          <p class="m-0">ลูกค้า</p>
                        </b-col>
                        <b-col lg="10" md="12" class="mb-3">
                          <b-form-input
                            size="sm"
                            v-model="jobDetails.customer_name"
                            disabled
                          ></b-form-input>
                        </b-col>
                        <b-col lg="2" md="12" class="text-lg-right mb-3">
                          <p class="m-0">ราคางาน</p>
                        </b-col>
                        <b-col lg="10" md="12" class="mb-3">
                          <b-form-input
                            size="sm"
                            v-model="jobDetails.job_price"
                            disabled
                          ></b-form-input>
                        </b-col>
                        <b-col lg="2" md="12" class="text-lg-right mb-3">
                          <p class="m-0">ประเภทการส่ง</p>
                        </b-col>
                        <b-col lg="10" md="12" class="mb-3">
                          <b-form-input
                            size="sm"
                            v-model="jobDetails.job_type"
                            disabled
                          ></b-form-input>
                        </b-col>
                        <b-col lg="2" md="12" class="text-lg-right mb-3">
                          <p class="m-0">ต้นทาง</p>
                        </b-col>
                        <b-col lg="10" md="12" class="mb-3">
                          <b-form-input
                            size="sm"
                            v-model="jobDetails.origin"
                            disabled
                          ></b-form-input>
                        </b-col>
                        <b-col lg="2" md="12" class="text-lg-right mb-3">
                          <p class="m-0">ปลายทาง</p>
                        </b-col>
                        <b-col lg="10" md="12" class="mb-3">
                          <b-form-input
                            size="sm"
                            v-model="jobDetails.destination"
                            disabled
                          ></b-form-input>
                        </b-col>
                        <b-col lg="2" md="12" class="text-lg-right mb-3">
                          <p class="m-0">ระยะทางทั้งหมด</p>
                        </b-col>
                        <b-col lg="10" md="12" class="mb-3">
                          <b-form-input
                            size="sm"
                            v-model="jobDetails.total_distance"
                            disabled
                          ></b-form-input>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-tab>
                <b-tab title="สินค้า">
                  <b-row>
                    <b-col cols="12"><h3>ข้อมูลสินค้า</h3></b-col>
                    <b-col cols="12">
                      <b-table
                        striped
                        responsive
                        hover
                        :fields="fields"
                        :items="jobDetails.items"
                      >
                        <template #cell(image)="data">
                          <b-img
                            :src="data.item.image"
                            fluid
                            width="100px"
                            rounded
                          ></b-img>
                        </template>
                      </b-table>
                    </b-col>
                  </b-row>
                </b-tab>
                <b-tab title="ผู้ขับ">
                  <b-row>
                    <b-col cols="12"><h3>ข้อมูลผู้ขับ</h3></b-col>
                    <b-col lg="2" md="12" class="text-lg-right mb-3">
                      <p class="m-0">ชื่อ-สกุล</p>
                    </b-col>
                    <b-col lg="4" md="12" class="mb-3">
                      <b-form-input
                        size="sm"
                        v-model="jobDetails.driver_name"
                        disabled
                      ></b-form-input>
                    </b-col>
                    <b-col lg="2" md="12" class="text-lg-right mb-3">
                      <p class="m-0">ประเภทรถ</p>
                    </b-col>
                    <b-col lg="4" md="12" class="mb-3">
                      <b-form-input
                        size="sm"
                        v-model="jobDetails.car_type"
                        disabled
                      ></b-form-input>
                    </b-col>
                    <b-col lg="2" md="12" class="text-lg-right mb-3">
                      <p class="m-0">ทะเบียนรถ</p>
                    </b-col>
                    <b-col lg="4" md="12" class="mb-3">
                      <b-form-input
                        size="sm"
                        v-model="jobDetails.car_no"
                        disabled
                      ></b-form-input>
                    </b-col>
                    <b-col lg="2" md="12" class="text-lg-right mb-3">
                      <p class="m-0">เบอร์โทรศัพท์</p>
                    </b-col>
                    <b-col lg="4" md="12" class="mb-3">
                      <b-form-input
                        size="sm"
                        v-model="jobDetails.driver_tel"
                        disabled
                      ></b-form-input>
                    </b-col>
                  </b-row>
                </b-tab>
                <b-tab title="รายการเบิกเพิ่ม">
                  <b-row>
                    <b-col cols="12"><h3>ข้อมูลรายการเบิกเพิ่มเติม</h3></b-col>
                    <b-col cols="12">
                      <b-table
                        striped
                        responsive
                        hover
                        :fields="fieldAdditionalWithdrawList"
                        :items="jobDetails.additional_withdraw_list"
                      >
                        <template #cell(image)="data">
                          <base-button type="info" class="" size="sm">
                            ดูรูปภาพ
                          </base-button>
                        </template>
                      </b-table>
                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>
            </b-col>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import jobs from "/src/db/list-job.json";

export default {
  components: {},
  props: {},
  data() {
    return {
      jobs,
      jobDetails: {},
      fieldAdditionalWithdrawList: [
        {
          key: "name",
          label: "ชื่อรายการ",
        },
        {
          key: "type",
          label: "ประเภท",
        },
        {
          key: "amount",
          label: "จำนวนเงิน",
        },
        {
          key: "image",
          label: "ใบเสร็จ",
        },
      ],
      fields: [
        {
          key: "name",
          label: "ชื่อรายการ",
        },
        {
          key: "image",
          label: "รูปภาพ",
        },
        {
          key: "type",
          label: "ประเภท",
        },
        {
          key: "dimension",
          label: "ขนาด",
        },
        {
          key: "weight",
          label: "น้ำหนัก",
        },
        {
          key: "no",
          label: "จำนวน",
        },
      ],
    };
  },
  created() {},
  methods: {
    getJob() {
      const job = jobs.find((job) => {
        return this.$route.params.id == job.id;
      });
      this.jobDetails = job;
    },
  },
  mounted() {
    this.getJob();
  },
};
</script>
<style scoped></style>
<style lang="scss" scoped></style>
